import { Liquid } from 'liquidjs/dist/liquid.browser.umd';
import Utils from './utils';

const BeansLiquidEngine = new Liquid({ cache: true });

BeansLiquidEngine.registerFilter('toLocaleString', (value) => value.toLocaleString());
BeansLiquidEngine.registerFilter('toJSONString', (value) => JSON.stringify(value));
BeansLiquidEngine.registerFilter('formatRank', (value) => Utils.formatRank(value));

export default BeansLiquidEngine;
